<template>
    <div class="account_manage">
        <div class="bread_crumb">
            账号管理 > 账号信息
        </div>
        <div class="main">
            <div class="top">
                <div class="left">
                    <!-- <span>账号信息</span>
                    <span>Account Information</span> -->
                </div>
                <div class="right">
                    <el-button size="medium" @click="save">{{isEdit?"保存":"编辑"}}</el-button>
                </div>
            </div>
            <el-form :model="accountObj" :rules="rules" ref="ruleForm" label-width="150px" >
            <div class="top-head">
                  <!-- <div class="top-title">
                    <span>联系人信息</span>
                </div> -->
                <el-descriptions title="联系人信息"  :column="2" :colon='false' size="mini">
                    <div class="top-title">
                    <span>联系人信息</span>
                  </div>
                    <el-descriptions-item label="联系人姓名：">
                         <el-form-item label="联系人姓名：" prop="linkman">
                         <el-input :disabled="!isEdit" v-model="accountObj.linkman" placeholder="请输入联系人姓名" style="width:239px"></el-input>
                </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item >
                        <el-form-item label="联系人电话：" prop="linkphone">
                    <el-input :disabled="!isEdit" v-model="accountObj.linkphone" placeholder="请输入联系人电话" style="width:239px"></el-input>
                </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item >
                         <el-form-item label="电子邮箱：" prop="email">
                    <el-input :disabled="!isEdit" v-model="accountObj.email" placeholder="请输入电子邮箱" style="width:239px"></el-input>
                </el-form-item>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <div class="conter">
               <el-descriptions title="单位信息" :column="2" :colon='false' size="mini">
                <el-descriptions-item >
                     <el-form-item label="机构全称：" prop="unitName">
                    <el-input :disabled="!isEdit" v-model="accountObj.unitName" placeholder="请输入机构全称" style="width:239px"></el-input>
                </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item>
                    <el-form-item label="统一社会信用代码" prop="unitCode">
				    <el-input :disabled="!isEdit" v-model="accountObj.unitCode" placeholder="请输入统一社会信用代码" style="width:239px"></el-input>
				</el-form-item>
                </el-descriptions-item>
                 <el-descriptions-item>
                    <el-form-item label="法人" prop="corporation">
				    <el-input :disabled="!isEdit" v-model="accountObj.corporation" placeholder="请输入法人" style="width:239px"></el-input>
				</el-form-item>
                </el-descriptions-item>
                 <el-descriptions-item>
                    <el-form-item label="身份证号码" prop="credentials">
				    <el-input :disabled="!isEdit" v-model="accountObj.credentials" placeholder="请输入法人" style="width:239px"></el-input>
				</el-form-item>
                </el-descriptions-item>
                <el-descriptions-item >
                    <el-form-item label="单位行业:" prop="tradeId1">
				    <el-col :span="11">
				        <el-form-item prop="tradeId1">
				            <el-select :disabled="!isEdit" v-model="accountObj.tradeId1" placeholder="请选择" @change="selectTrade">
				                <el-option v-for="item in trade1Data" :key="item.id" :label="item.name" :value="item.id"></el-option>
				            </el-select>
				        </el-form-item>
				    </el-col>
				    <el-col :span="1">&nbsp;</el-col>
				    <el-col :span="11">
				        <el-form-item prop="tradeId">
				            <el-select :disabled="!isEdit" v-model="accountObj.tradeId" placeholder="请选择">
				                <el-option v-for="item in trade2Data" :key="item.id" :label="item.name" :value="item.id"></el-option>
				            </el-select>
				        </el-form-item>
				    </el-col>
				</el-form-item>
                </el-descriptions-item>
                <el-descriptions-item >
                    <el-form-item label="单位性质：" prop="unitType">
					<el-select :disabled="!isEdit" v-model="accountObj.unitType" placeholder="请选择" style="width:239px">
						<el-option v-for="(item, index) in unitTypeName" :key="index" :label="item.typeName" :value="item.typeCode" ></el-option>
					</el-select>
				</el-form-item></el-descriptions-item>
                <el-descriptions-item >
                    <el-form-item label="单位注册地址：" prop="unitAddress">
				    <el-input :disabled="!isEdit" v-model="accountObj.unitAddress" placeholder="请输入单位注册地址" style="width:239px"></el-input>
				</el-form-item>
                </el-descriptions-item>
                <el-descriptions-item >
                  <el-form-item label="单位注册所在地域：" prop="provinceCode">
                    <el-col :span="8" style="padding-right:10px;">
                        <el-form-item prop="provinceCode">
                            <el-select :disabled="!isEdit" v-model="accountObj.provinceCode" placeholder="请选择省" @change="selectProvince">
                                <el-option v-for="item in provinceCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" style="padding-right:10px;">
                        <el-form-item prop="cityCode">
                            <el-select :disabled="!isEdit" v-model="accountObj.cityCode" placeholder="请选择市" @change="selectCity" >
                                <el-option v-for="item in cityCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" style="padding-right:10px;">
                        <el-form-item prop="areaCode">
                            <el-select :disabled="!isEdit" v-model="accountObj.areaCode" placeholder="请选择县">
                                <el-option v-for="item in areaCode" :key="item.id" :label="item.name" :value="item.id" ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item >
                    	<el-form-item label="营业执照：" prop="license">
					<el-upload
					    class="myupload"
						v-if="isEdit"
					    action=""
					    ref="upload" 
					    :limit="1" 
					    :on-change="uploadChange" 
					    :auto-upload="false" 
					    :show-file-list="false" 
					    :file-list="fileList"
					    accept=".jpg,.png,.jpeg,.gif">
					    <img :src="accountObj.license" width="150" height="150" alt="">
					    <el-button size="small">选择照片</el-button>
					    <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
					</el-upload>
					<img :src="accountObj.license" v-else width="150" height="150" alt="">
				    <!-- <el-input :disabled="!isEdit" v-model="accountObj.lisence" placeholder="请输入电子邮箱"></el-input> -->
				</el-form-item>
                </el-descriptions-item>
            </el-descriptions>
            </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {address, uploadFile, trade, unitType} from '@/api/home'
    import {accountInfo,updateInfo} from '@/api/admin'
export default {
    name:'AccountManage',
    data() {
         var validateIDcard = (rule, value, callback) => {
          var regExp = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            var IDcardReg=regExp.test(value)
            if (!IDcardReg) {
                callback(new Error('请输入正确的身份证号'));
            } else {
                callback();
            }
        };
      return {
		  fileList: [],//图片列表
		  unitTypeName: [], // 组织/单位性质
        rules: {
          name: [
            { required: true, message: '请输入活动名称', trigger: 'blur' },
            { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
            // linkman: [
        //     { required: true, message: '请输入联系人姓名', trigger: 'blur' },
        //     { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        //   ],
        //    linkphone: [
        //     { required: true, message: '请输入联系人电话', trigger: 'blur' }
        //   ],
        //   email: [
        //     { required: true, message: '请输入电子邮箱', trigger: 'blur' }
        //   ],
        //    unitName: [
        //     { required: true, message: '请输入机构全称', trigger: 'blur' }
        //   ],
        //    unitCode: [
        //     { required: true, message: '请输入组织机构代码', trigger: 'blur' }
        //   ],
        //   unitType: [
        //     { required: true, message: '请选择单位性质', trigger: 'change' }
        //   ],
        //   unitAddress: [
        //     { required: true, message: '请输入单位注册地址', trigger: 'change' }
        //   ],
        //   license: [
        //     { required: true, message: '请选择营业执照', trigger: 'change' }
        //   ],
          tradeId1: [
            { required: true, message: '请选择', trigger: 'change' }
          ],
           provinceCode: [
            { required: true, message: '请选择', trigger: 'change' }
          ],
          
          region: [
            { required: true, message: '请选择活动区域', trigger: 'change' }
          ],
          date1: [
            { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
          ],
          date2: [
            { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
          ],
          type: [
            { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
          ],
          resource: [
            { required: true, message: '请选择活动资源', trigger: 'change' }
          ],
          desc: [
            { required: true, message: '请填写活动形式', trigger: 'blur' }
          ],
		  cityCode: [
			{ required: true, message: '请选择城市', trigger: 'change' }
		  ],
		  areaCode: [
		  	{ required: true, message: '请选择区县', trigger: 'change' }
		  ],
		  tradeId: [
		  	{ required: true, message: '请选择行业', trigger: 'change' }
		  ],
           corporation: [
		  	{ required: true, message: '请输入法人', trigger: 'blur' }
		  ],
           credentials: [
		  	{ required: true, message: '请输入身份证号码', trigger: 'blur' },
            { validator: validateIDcard, trigger: 'blur' }
		  ],
        },
        provinceCode: [],//所属省
        cityCode: [],//所属市
        areaCode: [],//所属区县
        accountObj:{//账号信息
            linkman:'',//联系人姓名
            linkphone:'',//联系人电话
            email:'',//电子邮箱
            unitName:'',//机构全称
            provinceName:'',//所属省名称
            provinceCode:'',//所属省代码
            cityName:'',//所属市名称
            cityCode:'',//所属市代码
            areaName:'',//所属区县名称
            areaCode:'',//所属区县代码
			license: '',
            id:'',//单位ID
			tradeId1: "",//单位行业1
			tradeId: "",//单位行业2
			unitType: '',
			unitAddress: '',
			unitCode: '',
            corporation:'', // 法人
            credentials:'', // 法人身份证号码
        },
		trade1Data:[],//获取行业列表1
		trade2Data:[],//获取行业列表2
        isEdit:false,//是否是编辑  false--不能编辑 true--可以编辑
      }
    },
    mounted(){
        this.address()
		this.trade()
		this.qualityList()
    },
    methods:{
		trade(){//获取行业列表
		    trade({}).then(res=>{
		        // console.log('获取行业列表')
		        // console.log(JSON.parse(JSON.stringify(res.data)))
		        this.trade1Data=res.data||[]
		    })
		},
		// 获取单位性质数据
		qualityList() {
			unitType({}).then(res=>{
			    // console.log('获取单位性质列表')
			    // console.log(JSON.parse(JSON.stringify(res.data)))
			    this.unitTypeName=res.data||[]
			})
		},
		selectTrade(val){//选择行业
		    for (let i = 0; i < this.trade1Data.length; i++) {
		        if (val==this.trade1Data[i].id) {
		            this.trade2Data=this.trade1Data[i].children
		            break
		        }
		    }
		    this.accountObj.tradeId=''
		},
		uploadChange(file) {//根据资源上传指定目录
		    // console.log('选择文件');
		    // console.log(file);
		    let formData = new FormData();
		    formData.append("file", file.raw);
		    uploadFile(formData).then((res)=>{
		        // console.log('根据资源上传指定目录返回');
		        // console.log(res);
		        this.accountObj.license=res.data.url
		    }).catch((err)=>{
		        this.$message({
		            message: err.errmsg,
		            type: 'error',
		            duration: '2000',
		        })
		    })
		    this.fileList=[]
		},
        address(){//获取行政区划列表
            address({}).then(res=>{
                // console.log('获取行政区划列表')
                // console.log(JSON.parse(JSON.stringify(res.data)))
                this.provinceCode=res.data||[]
                // console.log(JSON.parse(JSON.stringify(this.provinceCode)))
                this.accountInfo()
            })
        },
        accountInfo(){//账号信息
            accountInfo({}).then(res=>{
                // console.log('账号信息')
                // console.log(JSON.parse(JSON.stringify(res.data.unitInfo)))
                for (let key in this.accountObj) {
                    if (key=='provinceCode'||key=='cityCode'||key=='areaCode'||key=='unitType') {
                        this.accountObj[key]=Number(res.data.unitInfo[key])
                    }else{
                        this.accountObj[key]=res.data.unitInfo[key]
                    }
                }
                for (let i = 0; i < this.provinceCode.length; i++) {
                    if (this.accountObj.provinceCode==this.provinceCode[i].id) {
                        this.cityCode=this.provinceCode[i].children
                        break
                    }
                }
                for (let i = 0; i < this.cityCode.length; i++) {
                    if (this.accountObj.cityCode==this.cityCode[i].id) {
                        this.areaCode=this.cityCode[i].children
                        break
                    }
                }
                // console.log(JSON.parse(JSON.stringify(this.accountObj)))
				let len = this.trade1Data.length;
				this.accountObj.tradeId = res.data.unitInfo.tradeId;
				for (let i = 0; i < len; i++) {
					let item = this.trade1Data[i];
					let length = item.children.length;
					for (let n = 0; n < length; n++) {
						let val = item.children[n];
						if (val.id == res.data.unitInfo.tradeId) {
							this.accountObj.tradeId1 = val.pid;
							this.trade2Data = item.children;
							break;
						}
					}
				}
            })
        },
        selectProvince(val){//选择省
            for (let i = 0; i < this.provinceCode.length; i++) {
                if (val==this.provinceCode[i].id) {
                    this.cityCode=this.provinceCode[i].children
                    break
                }
            }
            this.accountObj.cityCode=''
            this.accountObj.areaCode=''
            this.areaCode=[]
        },
        selectCity(val){//选择市
            for (let i = 0; i < this.cityCode.length; i++) {
                if (val==this.cityCode[i].id) {
                    this.areaCode=this.cityCode[i].children
                    break
                }
            }
            this.accountObj.areaCode=''
        },
        save(){//保存
			console.log(this.isEdit)
            if (this.isEdit) {//保存
                console.log('保存')
				this.$refs.ruleForm.validate(valid => {
					if (valid) {
						updateInfo(this.accountObj).then(res=>{
						    this.$message({
						        message: res.errmsg,
						        type: 'success',
						        duration: 2000,
						    });
						    this.isEdit=false
						})
					}
				})
                
            }else{//不可以编辑
                console.log('不可以编辑')
                this.isEdit=true
            }
        }
    }
}
</script>

<style lang='scss' scoped>
    .account_manage{
        // border: 1px solid #f00;
        // box-sizing: border-box;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        .bread_crumb{
            flex: none;
            font-size: 16px;
            font-weight: 600;
            color: #333;
        }
        .main{
            flex: 1;
            background-color: #fff;
            border-radius: 10px;
            margin-top: 20px;
            padding: 20px 28px;
            box-sizing: border-box;
             width: 100%;
            .top{
                display: flex;
                justify-content: space-between;
                align-items: center;
                // border-bottom: 1px solid #E6E6E6;
                // padding-bottom: 30px;
                .left{
                    span:nth-child(1){
                        font-size: 20px;
                        font-weight: 600;
                        color: #00AA73;
                    }
                    span:nth-child(2){
                        font-size: 16px;
                        font-weight: 400;
                        color: #808080;
                        margin-left: 10px;
                    }
                }
                .right{
                    .el-button{
                        border: 2px solid #00AA73;
                        width: 115px;
                        // height: 40px;
                        font-size: 16px;
                        // margin-right: 60px;
                        font-weight: 700;
                        color: #00AA73;
                    }
                }
            }
            .top-head{
                 background-color: #fff;
            border-radius: 10px;
            margin-top: 20px;
            padding: 18px 27px 10px 27px;
            box-sizing: border-box;
              box-shadow: 0px 0px 8px 0px rgba(172, 172, 172, 0.5);
            //   height: 150px;
             width: 100%;
              height: auto;
              ::v-deep {.el-descriptions__header{
                  border-bottom: 1px solid #E6E6E6;
                  padding-bottom: 14px;
                  
                  
              }
            }
            ::v-deep {.el-descriptions-item__label{
                      display: none;
              }
            }
            ::v-deep {.el-form-item{
                    margin-bottom: 15px;
                  }}
              .top-title{
                  font-size: 16px;
                border-bottom: 1px solid #E6E6E6;
                padding-bottom: 12px;
                letter-spacing: 1px;
              }
              .top-body{
                  display: flex;
                  flex-direction: row;
                  margin-top: 12px;
              }
            }
            .conter{
          background-color: #fff;
            border-radius: 10px;
            margin-top: 20px;
            padding: 18px 27px 10px 27px;
            box-sizing: border-box;
              box-shadow: 0px 0px 8px 0px rgba(172, 172, 172, 0.5);
            //   height: 150px;
              height: auto;
               width: 100%;
               ::v-deep { .el-descriptions__header{
                  border-bottom: 1px solid #E6E6E6;
                  padding-bottom: 14px;
                 
              }
            }
            ::v-deep { .el-descriptions-item__label{
                      display: none;
              }
            }
            ::v-deep {.el-form-item{
                    margin-bottom: 15px;
                  }
                }
            }
            .myform{
                // margin-top: 25px;
                // width: 500px;
            //    border-bottom: 1px solid #E6E6E6;
            }
        }
    }
</style>